// extracted by mini-css-extract-plugin
module.exports = {"add-column":"_2pCOxC9oiSY29tox6HFMoL","addColumn":"_2pCOxC9oiSY29tox6HFMoL"};